module.exports = {
    network: {
        development: {
            protocol: 'http',
            host: '127.0.0.1',
            port: '7545'
        },
        rinkeby: {
            protocol: 'https',
            host: 'rinkeby.infura.io/v3/7f9880d8f7ab42c4bf602a3a5b7d6dfd',
            port: ''
        }
    },
};